const summaries = {}

export default summaries
